module.exports = __webpack_public_path__ + "media/images/marketing/step2-955caf11a43b290acb90493bbbbe62cb2abeef08b856efe05cda9f8646bb1fcc.jpg";